import $api from '@/utils/api';
import Logger from '@/utils/logger';

export default {
  async registerFacilitator(userData) {
    const response = await $api.post(`/facilitators`, userData);

    if (!response.success) {
      throw new Error(response.message);
    }

    return response;
  },

  async activateFacilitator(facilitatorId, token) {
    const response = await $api.patch(`/facilitators/${facilitatorId}/activate`, { token });

    if (!response.success) {
      throw new Error(response.message);
    }

    return response;
  },

  async applyPasswordResetEmail(email) {
    const response = await $api.patch(`/facilitators/password/apply-reset`, { email });

    if (!response.success) {
      if (response.message === 'InvalidFacilitatorEmail') {
        throw new Error('Invalid email address.');
      } else {
        throw new Error(response.message);
      }
    }

    return response;
  },

  async updatePassword(data) {
    const response = await $api.patch(`/facilitators/password`, data);

    if (!response.success) {
      throw new Error('Password reset error.');
    }

    return response;
  },

  async verifyEmail(email) {
    const response = await $api.get(`/facilitators/email/${email}`);

    if (!response.success) {
      throw new Error(response.message);
    }

    return response;
  },

  async verifyPassword(password) {
    const response = await $api.patch(`/facilitators/password/verify`, { password });

    if (!response.success) {
      Logger.error(response.message);
      return { record: null };
    }

    return response;
  },

  async verifyPasswordResetToken(resetToken) {
    const response = await $api.patch(`/facilitators/password/verify-reset-token`, { resetToken });

    if (!response.success) {
      if (response.message === 'jwt expired') {
        throw new Error('Expired reset token.');
      } else {
        throw new Error(response.message);
      }
    }

    return response;
  },
};
